import { Tooltip, Box } from "@mui/material";

export const TimeDisplay = ({ timestamp }) => {
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);
    const diffInDays = Math.floor(diffInHours / 24);
    
    if (diffInHours < 24) {
      // Today - show time with "Today"
      return `Today, ${date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      })}`;
    } else if (diffInHours < 48) {
      // Yesterday
      return `Yesterday, ${date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      })}`;
    } else if (diffInDays < 7) {
      // Within week - show day name with time
      return `${date.toLocaleDateString('en-US', { weekday: 'short' })}, ${date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      })}`;
    } else {
      // Older - show date with time
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    }
  };

  const fullDateTime = new Date(timestamp).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    weekday: 'long'
  });

  return (
    <Tooltip title={fullDateTime} arrow placement="top">
      <Box sx={{ 
        fontSize: '0.875rem',
        color: 'grey.700',
        fontWeight: 500,
        whiteSpace: 'nowrap'
      }}>
        {formatDateTime(timestamp)}
      </Box>
    </Tooltip>
  );
};